import { MedicineDetails } from '@dreryk/drerykweb-medicine-api';

import { MedicineDetailsAdditionalInformationContent } from './MedicineDetailsAdditionalInformation/MedicineDetailsAdditionalInformationContent';
import { MedicineDetailsReimbursementsContent } from './MedicineDetailsReimbursementsContent';
import { MedicineDetailsTextContent } from './MedicineDetailsTextContent';

type MedicineDetailsContentProps = {
   readonly sectionKey: keyof MedicineDetails;
   readonly medicineDetails: MedicineDetails;
};

const MedicineDetailsContent = (props: MedicineDetailsContentProps): JSX.Element => {
   if (props.sectionKey === 'reimbursements') {
      return <MedicineDetailsReimbursementsContent reimbursements={props.medicineDetails[props.sectionKey]} />;
   }

   if (props.sectionKey === 'additionalMedicineInformation') {
      return (
         <MedicineDetailsAdditionalInformationContent additionalInformation={props.medicineDetails[props.sectionKey]} />
      );
   }

   return <MedicineDetailsTextContent text={props.medicineDetails[props.sectionKey]} />;
};

export { MedicineDetailsContent };
